import { render, staticRenderFns } from "./OrderTag.vue?vue&type=template&id=4139e7e9&"
import script from "./OrderTag.vue?vue&type=script&lang=js&"
export * from "./OrderTag.vue?vue&type=script&lang=js&"
import style0 from "./OrderTag.vue?vue&type=style&index=0&id=4139e7e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports